export default "__VITE_ASSET__Bp$qKkve__"